import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { WmcContext } from '../../../../../context/WmcContext';
import { DATA_TYPE, DT1, DT2, LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY } from '../../../../../api/AxiosApi';
// import WmsTab3Content from './wmsTabs/WmsTab3Content';
import WmsHeader from '../../../../../components/general/WmsHeader';
import DailyReportTab from '../../energy_reporting/DailyReportTab/DailyReportTab';
import { NavLink, useLocation } from 'react-router-dom';
import TopHeader from '../../../../../components/general/TopHeader';
import DailyPlant1 from '../plant1/DailyPlant1/DailyPlant1';
import HourlyPlant1 from '../plant1/HourlyPlant1/HourlyPlant1';
import MonthlyPlant1 from '../plant1/MonthlyPlant1/MonthlyPlant1';
import MonthlySumPlant1 from '../plant1/MonthlySumPlant1/MonthlySumPlant1';
import Plant1Sld from '../plant1/plantSLD/Plant1Sld';


export default function Plant3() {
    const { palette, typography, breakpoints, shape: { }, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    const [key, setKey] = useState('Daily Energy Log');
    const location = useLocation();
    // console.log('NAMEOFPATH', location.pathname);
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }
    return (
        <>
            <CssBaseline />
            {/* <WmsHeader /> */}
            <TopHeader />
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        Plant_03
                    </NavLink>
                    {/* <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {location.pathname}
                    </NavLink> */}
                </Stack>
                <Tabs
                    style={{ justifyContent: "flex-end", }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Daily Energy Log" title="Daily Energy Log">
                        <DailyPlant1 SUB_PLANT="PLANT_03" />
                    </Tab>

                    {/* <Tab eventKey="Hourly Energy Log" title="Hourly Energy Log">
                        <HourlyPlant1 SUB_PLANT="PLANT_03"/>
                    </Tab> */}
                    <Tab eventKey="Monthly Energy Log" title="Monthly Energy Log">
                        <MonthlyPlant1 SUB_PLANT="PLANT_03" />
                    </Tab>
                    <Tab eventKey="Monthly Energy Summary" title="Monthly Energy Summary">
                        <MonthlySumPlant1 SUB_PLANT="PLANT_03" />
                    </Tab>

                    <Tab eventKey="SLD" title="SLD">
                        <Plant1Sld SUB_PLANT="PLANT_03" />
                    </Tab>
                </Tabs>
            </Box>
        </>

    )
}
